import styled from 'styled-components'
import { device } from 'constants/media-query'

export const StyledPersonalDetailsContainer = styled.div`
  @media ${device.desktop} {
    margin-left: 36px;
  }
`
export const StyledTopPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const StyledDetailsMainTitle = styled.h1`
  font-size: 20px;
  font-weight: 500;
  height: 21px;
  text-align: start;
  margin-top: 3px;
`

export const StyledEditBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 28px;
  height: 28px;
  @media ${device.desktop} {
    width: 21px;
    height: 21px;
  }
`

export const StyledBottomPart = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.desktop} {
    flex-direction: row;
    gap: 64px;
    justify-content: flex-start;
  }

  img {
    width: 165px;
    height: 167px;
  }
`

export const StyledMiniTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: start;
  margin: 0;
  @media ${device.desktop} {
    text-wrap: auto;
  }
`

export const StyledImageContainer = styled.section`
  display: flex;
  width: 161px;
  height: 167px;
  border-radius: 4px;
  border: 1px solid black;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  @media ${device.desktop} {
    margin-top: 8px;
  }
`

export const StyledDetails = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 40px;
  @media ${device.desktop} {
    gap: 0 24px;
    font-size: 14px;
    font-weight: 400;
  }
`

export const StyledDetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  align-items: flex-start;
  &:nth-last-child(-n + 2) {
    grid-column: 1 / span 2;
  }
`

export const StyledDetailedSubTitle = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: start;
  margin: 0;
`
